<div class="cart-item" [ngClass]="{ 'disabled-item': item?.hasOwnProperty('parentEntryNumber')}">
  <!-- {{item | json}} -->
  <div class="item-details" (click)="goToDetail($event)">
    <div class="item-image">
      <cx-media [container]="item.product?.images?.PRIMARY" [format]="'thumbnail'"></cx-media>
    </div>
    <div class="item-info">
      <h3>{{ item.product.name }}</h3>
      <p class="item-description">{{ item.product.description || 'High-performance, low-GWP spray foaminsulation'}}</p>
      @if (item?.hasOwnProperty('parentEntryNumber')) {
      <div class="product-b-note">Auto-added Product B (Universal)</div>
      }
    </div>
  </div>
  <div class="item-price">${{formatPrice(item?.cwtDisplayPrice) }}/{{ item?.uom }}</div>
  <div class="quantity-control">
    <cwt-cart-item-counter [control]="addToCartForm.get('quantity')" (emitCount)="getLatestCount($event)"
      [disabled]="item?.hasOwnProperty('parentEntryNumber')" [max]="99">
    </cwt-cart-item-counter>
  </div>
  <div class="item-total">Drum</div>
  <div class="item-total">{{item.totalPrice?.formattedValue}}</div>
  @if (item?.hasOwnProperty('parentEntryNumber')) {
  <button class="remove-btn disable">×</button>
  } @else {
  <button class="remove-btn" title="Remove item" (click)="removeItem()">×</button>
  }
</div>